import { Table, TableBody, TableCell, TableHead, TableRow, withStyles } from '@material-ui/core';
import PrintHeader from './PrintHeader';
import { driverValueGetter } from '../utils';

const headerTitles = [
  'Pro#',
  'Customer',
  'City',
  'Return Code',
  'Driver',
  'Arrival Time',
  'Departure Time',
  'Contact Name',
  'Return Entered By'
];

const CustomTableCell = withStyles((theme) => ({
  head: {
    border: `1px solid ${theme.KPI.KPIButton}`
  },
  body: {
    fontSize: theme.textFontSize,
    border: `1px solid ${theme.KPI.KPIButton}`,
    padding: 4,
    paddingLeft: 8
  }
}))(TableCell);

const styles = (theme) => ({
  tableHead: {
    backgroundColor: theme.printTableHead
  },
  table: {
    margin: 0,
    marginTop: 16,
    width: '100%'
  },
  timeCell: {
    maxWidth: 30
  },
  nameCell: {
    maxWidth: 200,
    wordBreak: 'break-all'
  },
  tableRow: {
    pageBreakInside: 'avoid'
  }
});

const RenderTableHeaders = ({ classes }) => (
  <TableRow className={classes.tableRow}>
    {headerTitles.map((title, index) => (
      <CustomTableCell key={index} className={classes.timeCell}>
        {title}
      </CustomTableCell>
    ))}
  </TableRow>
);

const RenderTableRows = ({ printData, classes }) =>
  printData?.map((row) => (
    <TableRow key={row.proNumber} className={classes.tableRow}>
      <CustomTableCell className={classes.timeCell}>{row.proNumber}</CustomTableCell>
      <CustomTableCell className={classes.nameCell}>{row.displayCustomerName}</CustomTableCell>
      <CustomTableCell className={classes.nameCell}>{row.city}</CustomTableCell>
      <CustomTableCell className={classes.timeCell} align="center">
        {row.returnDetail.returnCode}
      </CustomTableCell>
      <CustomTableCell className={classes.nameCell}>
        {driverValueGetter({
          data: { driverName: row.driverName, driverNumber: row.driverNumber }
        })}
      </CustomTableCell>
      <CustomTableCell className={classes.timeCell} align="center">
        {row.arrivalTime}
      </CustomTableCell>
      <CustomTableCell className={classes.timeCell} align="center">
        {row.departureTime}
      </CustomTableCell>
      <CustomTableCell className={classes.nameCell}>
        {row.returnDetail.displayCustomerName}
      </CustomTableCell>
      <CustomTableCell className={classes.nameCell}>
        {row.returnDetail.returnEnteredBy}
      </CustomTableCell>
    </TableRow>
  ));

const PrintTable = ({
  classes,
  printData = [],
  setPrintRef,
  terminalCode,
  terminalOffset,
  totalReturnShipments
}) => {
  return (
    <div ref={setPrintRef}>
      <PrintHeader
        totalReturnShipments={totalReturnShipments}
        terminalOffset={terminalOffset}
        terminalCode={terminalCode}
      />
      <Table className={classes.table}>
        <TableHead className={classes.tableHead}>
          <RenderTableHeaders classes={classes} />
        </TableHead>
        <TableBody>
          <RenderTableRows printData={printData} classes={classes} />
        </TableBody>
      </Table>
    </div>
  );
};

export default withStyles(styles)(PrintTable);
